import { makeStyles } from "@material-ui/core";
import zIndex from "@material-ui/core/styles/zIndex";


export const LiveUnitNavSearchBarStyles = makeStyles(() => ({
    root: {
        backgroundColor: "transparent",
        left: 90,
        top: 15,
        width: "800px",
        zIndex: zIndex.appBar,
    },
}));

export const SearchBarStyles = makeStyles(() => ({
    root: {
        position: "absolute",
        padding: "1em 0",
        zIndex: zIndex.appBar,
        top: 0,
        right: 0,
    },
}));
